import styled from 'styled-components';

export const ImageWrapper = styled.div.withConfig({
    displayName: 'ImageWrapper',
    componentId: 'image-wrapper',
})([
    ({ alignment }) => `
     margin-bottom: ${alignment === 'Mittig' ? '32px' : '0'};

    .image-container {
        position: relative;
        width: 100%;
        ${alignment === 'Links' || alignment === 'Rechts' ? `
            display: flex;
            align-items: center;
            justify-content: center;
            aspect-ratio: 1 / 1;
            background-color: transparent;
        ` : `
            display: inline-block;
        `}
    }

    > .image-container > img {
        ${alignment === 'Links' || alignment === 'Rechts' ? `
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
        ` : `
            width: 100%;
            height: auto;
        `}
        transition: opacity 0.2s ease;
    }

    > p {
        margin: 8px 0;
        letter-spacing: 0.6px;
    }

    ${alignment === 'Links' || alignment === 'Rechts' ? `
        width: 50%;
        flex-shrink: 0;

        @media screen and (max-width: 767px) {
            width: 100%;
            margin-bottom: 16px;
        }
    ` : `
        width: 100%;
    `}
`,
]);

export const FullscreenButton = styled.div.withConfig({
    displayName: 'FullscreenButton',
    componentId: 'fullscreen-button',
})([
    `
    position: absolute;
    top: 8px;
    right: 8px;
    transition: opacity 0.2s ease;
    z-index: 10;

    button {
        svg {
            fill: #fff;
        }
    }
`,
]);
